<template>
  <b-modal id="call-result" v-model="visible" title="Kết quả cuộc gọi" hide-footer centered>
    <div>
      <!-- Select -->
      <b-form-group label="Trạng thái *:" label-for="statusSelect">
        <b-form-select v-model="currentStateCode" :options="statusOptions"></b-form-select>
      </b-form-group>

      <!-- Upload Images -->
      <div class="d-flex flex-wrap">
        <UploadMultiple2
          :title="'Ảnh xác thực *'"
          :maxFile="100"
          titleTag="h2"
          :uploadToApi="false"
          :isDragging="true"
          titleClass="form-inner-heading"
          ref="uploadImages"
        />
      </div>
    </div>

    <!-- Footer -->
    <div class="d-flex justify-content-end mt-4">
      <b-button variant="outline-danger" class="mr-2" @click="closeModal" :disabled="isLoading">
        <b-icon icon="x" scale="2" aria-hidden="true" />
        Thoát
      </b-button>
      <b-button variant="outline-primary" @click="handleSubmit" :disabled="isLoading">
        <b-spinner small v-show="isLoading" />
        <b-icon icon="check" scale="2" aria-hidden="true" v-show="!isLoading" />
        Cập nhật
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import UploadMultiple2 from '@/components/cskh/UploadMultiple2.vue'
  import { TicketService } from '@/services/ticket.service'
  import { showMess } from '@/config/utils'
  export default {
    name: 'CallResultModal',
    components: {
      UploadMultiple2,
    },
    data() {
      return {
        visible: false,
        currentStateCode: '',
        ticketId: '',
        isLoading: false,
        statusOptions: [
          {
            value: 'CONTACTED_MC_CONFIRM_CANCEL',
            text: 'Đã liên hệ MC - xác nhận hoàn hủy GD',
          },
          {
            value: 'MC_CONFIRM_SUCCESS',
            text: 'MC xác nhận cập nhật GD thành công',
          },
        ],
      }
    },
    methods: {
      closeModal() {
        this.visible = false
      },
      openModal(ticketId) {
        this.ticketId = ticketId
        this.currentStateCode = ''
        this.visible = true
      },
      async handleSubmit() {
        if (!this.currentStateCode) {
          showMess(this, 'Lỗi', 'Vui lòng chọn trạng thái', 'danger', 'b-toaster-top-right', 2500)
          return
        }

        if (this.$refs.uploadImages.getData().length === 0) {
          showMess(this, 'Lỗi', 'Vui lòng tải ảnh lên', 'danger', 'b-toaster-top-right', 2500)
          return
        }

        try {
          this.isLoading = true
          const imgs = await this.$refs.uploadImages.saveData()

          const body = {
            ticketId: this.ticketId,
            currentStateCode: this.currentStateCode,
            explanationImage: imgs,
          }

          const res = await TicketService.updateCallResult(body)
          if (res.code === 1000) {
            showMess(
              this,
              'Thành công',
              'Cập nhật thành công',
              'success',
              'b-toaster-top-right',
              2500
            )
            this.$emit('success', res.data)
            this.closeModal()
          } else {
            showMess(this, 'Thất bại', res.message, 'danger', 'b-toaster-top-right', 2500)
          }
        } catch (e) {
          showMess(
            this,
            'Thất bại',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            2500
          )
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>
